module.exports = "/static/assets/f3b12b6d76fdad0f243ca6b4fada53dd.png";